import { render } from "./home.vue?vue&type=template&id=dd3593a4&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=dd3593a4&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\DeepLink1-media版\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3593a4"]])

export default __exports__